export enum RoleConstant {
  globalAdminId = '7a91cad4-ef42-4eba-a157-6f5dd92fa916',
  companyAdminId = '53929e4c-27e0-4e22-a2e1-5a1ae1d685f0',
  srDirectorOperations = 'f5d6b6db-807f-4423-b443-d5dfb259c6e0',
  directorOperations = '59e4a0ac-0b71-44ae-a093-d16dc0c2f96d',
  supervisor = '777b7f2a-497a-4007-9e97-48380d918435',
  generalManager = 'c15b52e0-325e-45dd-91d2-fbc43b84611d',
  employeeId = '1dfacd6e-f53d-4878-9bb8-77c15a4402eb',
  vendorId = '0e709495-2180-4e9b-b17d-ee0a7d19f361',
  accountsPayableManager = '5ab187ce-e10e-432f-b3a0-99dba5a8b390',
  auditorId = '6a3ea82e-924c-42cc-bb23-51488a1ce796',

  accountsPayableManager1 = '77cbe51c-0ead-4c68-b42c-dadb34ca895a',
  accountsPayableManager2 = '0321710b-a305-4744-ac60-1d4c9855ee54',
  accountsPayableCreator = '25b84cf3-acd2-4739-ad28-7bd92ab4ad95',
  auditor1 = 'fbbb51fd-6d6d-4829-8293-7a556846fcf7',
  auditor2 = 'd2b8afb8-296b-4519-bc2f-55aaf6d68505',
  vpOperations = '695e0119-7c85-4cbc-9af5-8b7c1eee04a2',
  expenseInitiator = 'd612abb6-2001-408c-bb5f-8a4c603c1e01',
  RMmanager = '95ba515c-cefc-4302-8681-c106aa4726f2',
}

/** Roles that may create, edit, and delete announcements including company-wide scope. */
export const ANNOUNCEMENT_AUTHOR_ROLE_IDS: readonly string[] = [
  RoleConstant.companyAdminId,
  RoleConstant.accountsPayableManager1,
  RoleConstant.accountsPayableManager2,
  RoleConstant.auditor2,
];

/** VP, SDO, DO, AS (Supervisor), GM, Auditor 1, RM Manager — announcements limited to specific stores (no company-wide). */
export const ANNOUNCEMENT_HIERARCHY_AUTHOR_ROLE_IDS: readonly string[] = [
  RoleConstant.vpOperations,
  RoleConstant.srDirectorOperations,
  RoleConstant.directorOperations,
  RoleConstant.supervisor,
  RoleConstant.generalManager,
  RoleConstant.auditor1,
  RoleConstant.RMmanager,
];

/** Any role that may access announcements management (create/edit/delete per modal and API rules). */
export const ANNOUNCEMENT_ANY_AUTHOR_ROLE_IDS: readonly string[] = [
  ...ANNOUNCEMENT_AUTHOR_ROLE_IDS,
  ...ANNOUNCEMENT_HIERARCHY_AUTHOR_ROLE_IDS,
];
